import React from "react";
import { Text } from "./typography";
import { GatedPrice } from "./gated-price";
import { dollarFormat } from "../../utils";
import type { TypographyVariant, TypographyTone } from "./typography/types";

interface CurrencyAmountProps {
  amount: number | null | undefined;
  currency?: string;
  variant?: TypographyVariant;
  tone?: TypographyTone;
}

export const CurrencyAmount: React.FC<CurrencyAmountProps> = ({
  amount,
  currency = "QAR",
  variant = "body",
  tone = "dark",
}) => {
  if (amount === null || amount === undefined) {
    return (
      <Text variant={variant} tone={tone} inline as="span">
        —
      </Text>
    );
  }

  return (
    <Text variant={variant} tone={tone} inline as="span">
      <GatedPrice>{dollarFormat(amount, currency)}</GatedPrice>
    </Text>
  );
};
